import { httpCreate } from './http';

const http = httpCreate('/shop/api/phy-activity-store');

export const phyActivityStore = {
	getLiveStore(activityId, params) {
		return http.get(`/page/${activityId}`, { params });
	},
	saveLiveStore(activityId, data) {
		return http.put(`/save/${activityId}`, data);
	},
	getLiveConfig(activityId) {
		return http.get(`/config/${activityId}`);
	},
	saveLiveConfig(activityId, params) {
		return http.put(`/config/${activityId}`, {}, { params });
	},
	removeLiveStoreItem(activityId, phyStoreId) {
		return http.delete(`/${activityId}/remove-store/${phyStoreId}`);
	},
};
